import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface Indicator {
  id: string
  kpiDefinitionId: string
  kpiName: string
  assetId: string | null
  isKpiEnabled: boolean
  isAlarmApplicable: boolean
  isAlarmEnabled: boolean
  alarmHigherLimitSeverity: string | null
  alarmLowerLimitSeverity: string | null
  isCustomKpi: boolean
  tenantId: string | null
  unit: string | null
  isDefaultConfig: boolean | false
  executionFrequencyMinutes: number | null
  alarmLowerLimit: number | null | string
  alarmLowerLimitStateText: string | null
  alarmLowerLimitTextColorId: string | null
  alarmLowerLimitColorName: string | null
  alarmLowerLimitColorValue: string | null
  alarmLowerLimitSeverityId: string | null
  alarmLowerLimitSeverityLevel: string | null
  alarmLowerLimitLabelId: string | null
  alarmLowerLimitLabelName: string | null
  alarmLowerLimitRecommendationText: string
  alarmHigherLimit: string | null | string
  alarmHigherLimitStateText: string
  alarmHigherLimitTextColorId: string | null
  alarmHigherLimitColorName: string | null
  alarmHigherLimitColorValue: string | null
  alarmHigherLimitSeverityId: string | null
  alarmHigherLimitSeverityLevel: string | null
  alarmHigherLimitLabelId: string | null
  alarmHigherLimitLabelName: string | null
  alarmHigherLimitRecommendationText: string
  isTotalizer?: boolean

  isLowerLimitAlarmEnabled: boolean | false
  lowerLimitOperator: string | null
  isHigherLimitAlarmEnabled: boolean | false
  higherLimitOperator: string | null
}
export interface indicatorsState {
  isLoading: boolean
  loadingError: string | null
  indicators: Indicator[] | null
  httpStatus: number | null
}

export const initialState: indicatorsState = {
  isLoading: true,
  loadingError: null,
  indicators: null,
  httpStatus: null
}

export const indicatorSlice = createSlice({
  name: 'indicatorSlice',
  initialState,
  reducers: {
    indicatorLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        indicators: null,
        httpStatus: 0
      }
    },
    indicatorUpdateAction: (state, action: PayloadAction<{ data: Indicator[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        indicators: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    indicatorErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        indicators: null,
        httpStatus: action.payload.httpStatus
      }
    },
    indicatorReset: () => initialState
  }
})

export const {
  indicatorLoadingAction,
  indicatorUpdateAction,
  indicatorErrorAction,
  indicatorReset
} = indicatorSlice.actions

export default indicatorSlice.reducer
